// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608251600/js/" + chunkId + "." + {"44":"99fc17c9","225":"baebbf54","481":"183e569b","486":"37b78db7","770":"1baca539"}[chunkId] + ".0.438884413919573.chunk.js";
};